import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["link"]

  connect() {
    this.observer = new IntersectionObserver(this.update.bind(this), {
      rootMargin: "-50% 0px -50% 0px",
    })
    this.element
      .querySelectorAll("li[id]")
      .forEach((module) => this.observer.observe(module))
  }

  disconnect() {
    this.observer?.disconnect()
  }

  update(entries) {
    entries.forEach((entry) => {
      if (!entry.isIntersecting) return
      const anchor = `#${entry.target.id}`
      this.linkTargets.forEach((link) => {
        link.dataset.active = link.getAttribute("href") === anchor
      })
    })
  }
}
